// Realpad vracia pre etapu boryNoveBloky počet izieb s príponou KK (napr. "2KK", "1,5KK-A"),
// ostatné etapy vracajú čisté číslo ("2", "1,5"). Zoznam bytov sa normalizuje v mutácii
// retrievedFlats, detail bytu a porovnávač si však ťahajú vlastný request, takže si dáta
// musia normalizovať sami - preto je parsovanie na jednom mieste tu.
const ROOMS_SUFFIX = /KK(-A)?$/i

// Nadpisy podľa počtu izieb. Hodnoty sú slovenské kľúče pre $t().
// "1,5" tu zámerne nie je - každý komponent ho zobrazuje po svojom.
const ROOM_TITLES: { [rooms: string]: string } = {
  '1': 'Jednoizbový byt',
  '2': 'Dvojizbový byt',
  '3': 'Trojizbový byt',
  '4': 'Štvorizbový byt',
  '5': 'Päťizbový byt',
  '6': 'Šesťizbový byt',
  '7': 'Sedemizbový byt',
  '8': 'Osemizbový byt',
  '9': 'Deväťizbový byt'
}

interface Flat {
  // eslint-disable-next-line @typescript-eslint/camelcase
  flat_number_of_rooms?: string;
  // eslint-disable-next-line @typescript-eslint/camelcase
  flat_disposition?: string;
}

export function normalizeNumberOfRooms(rooms?: string): string | undefined {
  if (!rooms) {
    return rooms
  }

  return String(rooms).replace(ROOMS_SUFFIX, '')
}

// Prepíše flat_number_of_rooms priamo v objekte bytu a byt vráti.
export function normalizeFlat<T extends Flat>(flat: T): T {
  if (flat && flat.flat_number_of_rooms) {
    // eslint-disable-next-line @typescript-eslint/camelcase
    flat.flat_number_of_rooms = normalizeNumberOfRooms(flat.flat_number_of_rooms)
  }

  return flat
}

// Kľúč nadpisu pre $t(), null ak počet izieb nevieme priradiť.
export function roomsTitle(flat: Flat): string | null {
  if (!flat) {
    return null
  }

  const rooms = normalizeNumberOfRooms(flat.flat_number_of_rooms)

  return (rooms && ROOM_TITLES[rooms])
    || (flat.flat_disposition && ROOM_TITLES[flat.flat_disposition])
    || null
}
